import * as actions from './dlrActions';

const initialState = {
  selected: '',
  appProfile: '',
};

const dlrReducers = {
  [actions.DLR_DLRLR_CLEAR_DATA]: () => initialState,
  [actions.DLR_REMOVE_ADDRESS_DATA]: state => {
    delete state.renewalHomeAddress;
    delete state.renewalMailingAddress;
    delete state.mailingSameAsHomeAddress;
    return state;
  },
  [actions.DLR_REMOVE_VOTING_DATA]: state => {
    delete state.organDonorOption;
    delete state.voterRegistration;
    delete state.voterRegistrationAppType;
    delete state.volunteerElectionJudge;
    return state;
  },

  [actions.DLR_CLEAR_COUNTY_DATA]: state => {
    state.renewalMailingAddress.county = 'OTHER';
    return state;
  },

  [actions.DLR_RENEW_LICENSE]: (state, { payload }) => {
    return { ...state, ...{ selected: payload } };
  },
  [actions.DLR_STORE_APP_PROFILE]: (state, { payload }) => {
    return { ...state, ...{ appProfile: payload } };
  },
  [actions.DLR_RENEW_HOME_ADDRESS_UPDATE]: (state, { payload }) => {
    return { ...state, ...{ renewalHomeAddress: payload } };
  },
  [actions.DLR_RENEW_MAILING_ADDRESS_UPDATE]: (state, { payload }) => {
    return { ...state, ...{ renewalMailingAddress: payload } };
  },
  [actions.DLR_UPDATE_MAILING_ADDRESS_AS_HOME]: (state, { payload }) => {
    return { ...state, ...{ mailingSameAsHomeAddress: payload } };
  },
  [actions.DLR_SURRENDER_CARD]: (state, { payload }) => {
    return { ...state, ...{ surrenderCardOption: payload } };
  },
  [actions.DLR_SURRENDER_CARD_PAGE_SELECTION]: (state, { payload }) => {
    return { ...state, ...{ surrenderCardPageSelection: payload } };
  },
  [actions.DLR_REPLACE_OR_CHANGE_ADDRESS]: (state, { payload }) => {
    return { ...state, ...{ renewAddressChangeFlag: payload } };
  },
  [actions.DLR_DONATION_OPTIONS]: (state, { payload }) => {
    return { ...state, ...{ donationOptions: payload } };
  },
  [actions.DLR_DONATION_VALUES]: (state, { payload }) => {
    return { ...state, ...{ donationValues: payload } };
  },
  [actions.DLR_ORGAN_DONOR_OPTION]: (state, { payload }) => {
    return { ...state, ...{ organDonorOption: payload } };
  },
  [actions.DLR_VOTER_REGISTRATION]: (state, { payload }) => {
    return { ...state, ...{ voterRegistration: payload } };
  },
  [actions.DLR_VOLUNTEER_ELECTION_JUDGE]: (state, { payload }) => {
    return { ...state, ...{ volunteerElectionJudge: payload } };
  },
  [actions.DLR_VOTER_REGISTRATION_APPLICATION_TYPE]: (state, { payload }) => {
    return { ...state, ...{ voterRegistrationAppType: payload } };
  },
  [actions.DLR_EMERGENCY_CONTACTS]: (state, { payload }) => {
    return { ...state, ...{ emergencyContacts: payload } };
  },
  [actions.DLR_EMERGENCY_CONTACTS_INITIAL]: (state, { payload }) => {
    return { ...state, ...{ emergencyContactsInitial: payload } };
  },
  [actions.DLR_EMERGENCY_CONTACTS_FAILED_STATUS]: (state, { payload }) => {
    return { ...state, ...{ emergencyContactsFailedStatus: payload } };
  },
  [actions.DLR_DLS_EMERGENCY_CONTACTS_HAS_DATA]: (state, { payload }) => {
    return { ...state, ...{ isDlsEmergencyContactsHasData: payload } };
  },
  [actions.DLR_PAYMENT_TRANSACT_SUCCESS]: (state, { payload }) => {
    return { ...state, ...{ paymentTransactSuccess: payload } };
  },
  [actions.DLR_IS_ADDRESS_UPDATE]: (state, { payload }) => {
    return { ...state, ...{ isAddressUpdate: payload } };
  },
  [actions.DLR_UPDTAE_EMERGENCY_FLAG]: (state, { payload }) => {
    return { ...state, ...{ updateEmergencyFlag: payload } };
  },
  [actions.DLR_RENEWAL_FLAG]: (state, { payload }) => {
    return { ...state, ...{ renewalFlag: payload } };
  },
  [actions.DLR_UPGRADE_FLAG]: (state, { payload }) => {
    return { ...state, ...{ upgradeFlag: payload } };
  },
  [actions.DLR_JOINT_RENEWAL_UPGRADE_FLAG]: (state, { payload }) => {
    return { ...state, ...{ jointRenewalUpgradeFlag: payload } };
  },
  [actions.DPS_MESSAGE_BANNER_ONLOAD]: (state, { payload }) => {
    return { ...state, ...{ dpsMessageBannerOnLoad: payload } };
  },
  [actions.DLR_UPDATE_PAYMENT_WAS_MADE]: (state, { status }) => {
    return { ...state, ...{ paymentWasMade: status } };
  },
};

export default {
  name: 'dps',
  reducers: dlrReducers,
};
